<div class="content-wrapper" [class.sticky-padding]="sticky" #composite>
  <div class="product-wrapper">
    <div class="product-section">
      @if (product) {
        <div class="product-image-description">
          @if (product) {
            <div class="mobile-image keen-slider" #mobileImgSliderRef>
              <img class="keen-slider__slide" [src]="product | primary" [alt]="product.productDisplayName" />
              @for (image of product.imageUrls; track image) {
                <img class="keen-slider__slide" [src]="image | cms" [alt]="product.productDisplayName" />
              }
            </div>
          }
          <div class="desktop-product-images" [ngClass]="OnlineImageClass[product.onlineImageStyle]">
            <!-- <div *ngIf="!product.productDeliveryLimit?.hidden && product.productDeliveryLimit as deliveryLimit" class="delivery-limit badge">{{ deliveryLimit.label }}</div>
            <img *ngIf="product.badgeUrl as badgeUrl" class="product-badge" [src]="badgeUrl | cms : 75 : 80" alt="badge" /> -->
            <img [src]="product | primary" [alt]="product.productDisplayName" (click)="openCarousel(0)" />
            @if (product.imageUrls?.length && product.onlineImageStyle !== OnlineImageStyle.One) {
              @if (product.imageUrls[0]) {
                <img [src]="product.imageUrls[0] | cms" [alt]="product.productDisplayName" (click)="openCarousel(1)" />
              }
              @if (product.imageUrls[1] && product.onlineImageStyle === OnlineImageStyle.Five) {
                <img [src]="product.imageUrls[1] | cms" [alt]="product.productDisplayName" (click)="openCarousel(2)" />
              }
              @if (product.imageUrls[2] && product.onlineImageStyle === OnlineImageStyle.Five) {
                <img [src]="product.imageUrls[2] | cms" [alt]="product.productDisplayName" (click)="openCarousel(3)" />
              }
              @if (product.imageUrls[3] && product.onlineImageStyle === OnlineImageStyle.Five) {
                <img [src]="product.imageUrls[3] | cms" [alt]="product.productDisplayName" (click)="openCarousel(4)" />
              }
            }
          </div>
          <section class="product-descriptions">
            @if (product.productDescription) {
              @if (product.productDisplayTitle) {
                <h2>{{ product.productDisplayName }}</h2>
              }
              <div [innerHTML]="product.productDescription | sanitizeHtml" class="rich-text"></div>
            }
          </section>
        </div>
        <div class="product-details">
          <section class="product-header">
            <div class="product-summary">
              <h1 class="product-details-name">{{ product.productDisplayTitle || product.productDisplayName }}</h1>
              @if (product.summary) {
                <span class="product-details-summary">{{ product.summary }}</span>
              }
            </div>
            <div class="product-price">
              @if (product.altPriceText && compositePrice === 0) {
                <span class="price-text">{{ product.altPriceText }}</span>
              }
              @if (!product.isAdvertisement && !(product.altPriceText && compositePrice === 0)) {
                <app-price [value]="compositePrice" class="price-text"></app-price>
              }
              @if (product.discountLevels?.length) {
                <div class="discount-levels">
                  @for (discountLevel of product.discountLevels; track discountLevel.id) {
                    <div>
                      <span>{{ discountLevel.displayText }}</span>
                      @if (!discountLevel.hidePercentPerQuantity) {
                        <span> {{ discountLevel.discountPercent }}% for {{ discountLevel.minimumQuantity }} stk. </span>
                      }
                    </div>
                  }
                </div>
              }
              <!-- <span *ngIf="product.splash && product.originalPrice !== product.price" class="product-card-original-price">
              {{ originalPriceLabel }} {{ product.originalPrice | number : '.2-2' : locale }}
            </span> -->
              @if (product.infoText) {
                <span class="product-info-text">{{ product.infoText }}</span>
              }
            </div>
            @if (product.onlineProductLinks?.length) {
              <div class="product-links">
                <span>{{ product.onlineProductLinksName }}</span>
                <div class="links">
                  @for (link of product.onlineProductLinks; track $index) {
                    <a [routerLink]="productUrl + link.productUrl + '-' + link.productId" routerLinkActive="active">
                      {{ link.name }}
                    </a>
                  }
                </div>
              </div>
            }
            <div #mainModuleTarget class="target"></div>
            <div class="main-product-modules">
              @for (module of product.productModules; track module.id) {
                @if (module.main) {
                  <ng-select
                    #mainModuleSelect
                    [searchable]="false"
                    [clearable]="module.minPickCount === 0"
                    [placeholder]="module.name"
                    (change)="add(module, $event, 1)"
                    [closeOnSelect]="module.maxPickCount === 1"
                    [multiple]="module.maxPickCount !== 1"
                    [maxSelectedItems]="module.maxPickCount === 0 ? module.products.length : module.maxPickCount"
                    (add)="add(module, $event, 1)"
                    (remove)="remove(module, $event, 1)"
                    (clear)="clearSelected(module)"
                  >
                    @if (module.maxPickCount !== 1) {
                      <ng-template ng-label-tmp></ng-template>
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="select-multi-label">
                          <span>{{ module.name }}</span> <span>{{ items.length }} valgt</span>
                        </div>
                      </ng-template>
                    }
                    @for (option of module.products; track option.id) {
                      <ng-option [value]="option.id">
                        {{ option.productDisplayName }}
                        @if (option.price) {
                          <app-price [value]="option.price"></app-price>
                        }
                      </ng-option>
                    }
                  </ng-select>
                }
              }
            </div>
          </section>
          @for (outerIconLine of iconLines; track outerIconLine.title) {
            <div class="icon-lines">
              <h3>{{ outerIconLine.title }}</h3>
              @for (innerIconLine of outerIconLine.lines; track innerIconLine) {
                <div>
                  <img [src]="contentUrl + innerIconLine.icon" />
                  <label>{{ innerIconLine.text }}</label>
                </div>
              }
            </div>
          }
          <div class="product-buttons">
            @if (hasSimpleModules) {
              <app-text-button class="basket-button" (click)="validateRequiredAndScroll(mainModuleTarget, modulesTarget)">
                {{ product.productPageButtonText ? product.productPageButtonText : 'Vælg' }}
              </app-text-button>
            }
            @if (!hasSimpleModules) {
              @let entry = simpleProduct ? isProductLine((basketProducts | async)[product.id]) : (basketProductLine | async);
              <div class="controls" #controls>
                <div>
                  @if (!entry && !product.isAdvertisement) {
                    <app-text-button
                      [disabled]="!product.forSale || !validated"
                      class="basket-button"
                      (click)="addToBasket(composition.minCount)"
                    >
                      {{ product.forSale ? sharedContent.addToBasketLabel : sharedContent.productNotForSale }}
                    </app-text-button>
                  }
                  @if (entry && !product.isAdvertisement) {
                    <app-counter
                      [minCount]="product.minCount"
                      [count]="entry.quantity"
                      (add)="addToBasket($event.quantity)"
                      (remove)="removeFromBasket(entry.quantity, $event.quantity)"
                    ></app-counter>
                  }
                  @if (product.isAdvertisement) {
                    <app-text-button [disabled]="!product.forSale" class="basket-button" [routerLink]="contactUsUrl">
                      {{ sharedContent.contactUs }}
                    </app-text-button>
                  }
                  <!-- <app-icon-button *ngIf="entry" class="delete-line" [icon]="deleteIcon" (click)="deleteFromBasket()"></app-icon-button> -->
                </div>
                @if (!simpleProduct && lineId | async) {
                  <div class="buy-more">
                    <app-text-button (click)="buyMore()">Køb mere</app-text-button>
                  </div>
                }
              </div>
            }
            @if (!product.isAdvertisement) {
              <div class="sale-status">
                @if (product.forSale) {
                  <div class="green"><span></span> {{ inStockLabel }}</div>
                }
                @if (!product.forSale) {
                  <div class="red"><span></span> {{ notInStockLabel }}</div>
                }
              </div>
            }
          </div>
          <div class="infoboxes">
            @for (outerBox of infoboxes; track $index) {
              @for (innerbox of outerBox.infoboxes; track innerbox.title) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>{{ innerbox.title }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div [innerHTML]="innerbox.info | sanitizeHtml" class="rich-text"></div>
                </mat-expansion-panel>
              }
            }
          </div>
          @if (!hasSimpleModules) {
            <section class="mobile-product-descriptions">
              @if (product.productDescription) {
                @if (product.productDisplayTitle) {
                  <h2>{{ product.productDisplayName }}</h2>
                }
                <div [innerHTML]="product.productDescription | sanitizeHtml" class="rich-text"></div>
              }
            </section>
          }
          <!-- <div class="product-small-additions" *ngIf="product.productAdditions?.length && product.productAdditions[0] as productAddition">
        <ng-container *ngIf="productAddition.display">
          <h2>{{ productAddition.name }}</h2>
          <div class="keen-slider" #productAdditionSliderRef>
            <app-small-online-product-card
              *ngFor="let card of productAddition.products"
              class="keen-slider__slide"
              [product]="card"
            ></app-small-online-product-card>
          </div>
        </ng-container>
      </div> -->
        </div>
        <div #modulesTarget class="target"></div>
        @if (hasSimpleModules) {
          <div class="product-modules">
            @for (module of product.productModules; track module.id) {
              @if (!module.main) {
                <app-product-picker
                  [module]="module"
                  [composition]="composition"
                  [locked]="!!(basketProductLine | async)"
                  [highlightRequired]="requiredModules[module.id]"
                  [pictureCards]="module.pictureCards"
                  (add)="add(module, $event[1].id, $event[3], $event[2])"
                  (remove)="remove(module, $event[1].id, $event[3])"
                ></app-product-picker>
              }
            }
          </div>
          <section class="mobile-product-descriptions has-simple-modules">
            @if (product.productDescription) {
              @if (product.productDisplayTitle) {
                <h2>{{ product.productDisplayName }}</h2>
              }
              <div [innerHTML]="product.productDescription | sanitizeHtml" class="rich-text"></div>
            }
          </section>
        }
      }
    </div>
  </div>

  @if (strips?.length) {
    <app-strip-container [strips]="strips"></app-strip-container>
  }

  @for (productAddition of product.productAdditions; track productAddition.id) {
    <div class="product-additions product-wrapper">
      @if (productAddition.display) {
        <h2>{{ productAddition.name }}</h2>
        @if (productAddition.carousel) {
          <div class="keen-slider" #productAdditionSliderRef>
            @for (card of productAddition.products; track card.id) {
              <app-online-product-card class="keen-slider__slide" [product]="card"></app-online-product-card>
            }
          </div>
        }
        @if (!productAddition.carousel) {
          <div class="static">
            @for (card of productAddition.products; track card.id) {
              <app-online-product-card [product]="card"></app-online-product-card>
            }
          </div>
        }
      }
    </div>
  }
</div>

<div class="total" [class.sticky]="sticky" [@openClose]="stickyOpen ? 'open' : 'closed'" #stickyBottom>
  @let entry = simpleProduct ? isProductLine((basketProducts | async)[product.id]) : (basketProductLine | async);
  @if (entry) {
    <div @slide class="buy-more">
      @if (product.hasModules) {
        <app-text-button (click)="buyMore()">Køb mere</app-text-button>
      }
      <app-text-button [routerLink]="basketOverviewUrl">Kurv</app-text-button>
    </div>
  }
  <div class="total-price">
    <label>{{ product.productDisplayName }}</label>
    @if (showAltPrice && product.altPriceText) {
      <span>{{ product.altPriceText }}</span>
    }
    @if (!(showAltPrice && product.altPriceText) && !entry) {
      <span> {{ compositePrice * (1 - discountLevelPercent / 100) | number: '.2-2' : locale }} {{ currency | displayCurrency }} </span>
    }
    @if (!(showAltPrice && product.altPriceText) && entry) {
      <span> {{ entry | sum | number: '.2-2' : locale }} {{ currency | displayCurrency }} </span>
    }
  </div>
  <div class="total-controls">
    @if (!entry && !product.isAdvertisement) {
      <app-text-button [disabled]="!product.forSale || !validated" class="basket-button" (click)="addToBasket(composition.minCount)">
        {{ product.forSale ? sharedContent.addToBasketLabel : sharedContent.productNotForSale }}
      </app-text-button>
    }
    @if (entry && !product.isAdvertisement) {
      <app-counter
        [minCount]="product.minCount"
        [lockRemove]="entry.quantity === composition.minCount"
        [count]="entry.quantity"
        (add)="addToBasket($event.quantity)"
        (remove)="removeFromBasket(entry.quantity, $event.quantity)"
      ></app-counter>
    }
    @if (entry && !product.isAdvertisement) {
      <app-icon-button class="delete-line" [icon]="deleteIcon" (click)="deleteFromBasket()"></app-icon-button>
    }
    @if (entry && product.isAdvertisement) {
      <app-text-button [disabled]="!product.forSale" class="basket-button" [routerLink]="contactUsUrl">
        {{ sharedContent.contactUs }}
      </app-text-button>
    }
  </div>
</div>
